module.exports = __webpack_public_path__ + "static/media/page3.4e3cb2e3.png";